import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/sideNav/admin.svg")